<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<elder-basic-pane-layout class="full">
  <elder-pane>
    <app-production-list class="flex"> </app-production-list>
  </elder-pane>
</elder-basic-pane-layout>
